import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

/** True when the reader’s UI language is English (`en`, `en-*`). */
function isEnglish(language: string | undefined): boolean {
  return (language ?? 'en').toLowerCase().split('-')[0] === 'en';
}

/**
 * #2109 R3-B10 (as R2-B12 ruled for the wizard): consent wording stays in
 * English and authoritative. Beside it, a reader in another language gets
 * ONE line in their language that says so. An English reader sees nothing.
 * TRF ruled this as built on 2026-10-16 (`consent-english-authoritative`).
 */
export function ConsentEnglishNotice({ className }: { className?: string }) {
  const { t, i18n } = useTranslation('consent');
  if (isEnglish(i18n.language)) return null;
  return (
    <p role="note" data-testid="consent-english-notice" className={cn('text-caption text-stevens-ink-3', className)}>
      {t('englishNotice')}
    </p>
  );
}
